'use client';

import { useAtomValue } from 'jotai';
import Link from 'next/link';
import { theme } from '../../store/theme';
import styles from './ClutchButton.module.scss';
import Img from '../../components/Img';

interface IClutchButtonProps {
  title: string;
  starsCount: number;
  link: string;
}

const ClutchButton = ({ title, starsCount, link } : IClutchButtonProps) => {
  const appTheme = useAtomValue(theme);

  return (
    <Link
      href={link}
      className={styles.clutchLink}
    >
      <div className={styles.titleWrapper}>
        <Img
          src={`/media/clutch_${appTheme}.svg`}
          alt='clutch'
          width={44}
          height={12}
          className={styles.logo}
        />
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.stars}>
        {new Array(starsCount).fill(0).map((item, index) => (

          <svg // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={styles.star}
          >
            <use
              xlinkHref='/media/star.svg#star'
              href='/media/star.svg#star'
            />
          </svg>
        ))}
      </div>
    </Link>
  );
};

export default ClutchButton;
